module.exports = __webpack_public_path__ + "img/us-hi.d8339d25.svg";